// extracted by mini-css-extract-plugin
export var contactPoint = "style-module--contact-point--dc1e0";
export var contentBlock = "style-module--content-block--e77e2";
export var padding = "style-module--padding--3e1cb";
export var table = "style-module--table--0de11";